// Dynamically load the Google Maps JS API with Places library
// Usage: await loadGoogleMapsPlaces(process.env.REACT_APP_GOOGLE_MAPS_API_KEY)
export function loadGoogleMapsPlaces(apiKey) {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined") {
      return reject(new Error("Window is not available"));
    }

    // If already loaded with places, resolve immediately
    if (window.google && window.google.maps && window.google.maps.places) {
      try {
        if (process.env.NODE_ENV !== "production") {
          console.log("[Maps] Google Maps JS API (Places) already loaded");
        }
      } catch (_) {}
      return resolve(window.google);
    }

    if (!apiKey) {
      return reject(
        new Error(
          "Missing Google Maps API key. Set REACT_APP_GOOGLE_MAPS_API_KEY in your environment."
        )
      );
    }

    // If a loader is already in-flight, hook into it
    if (window.__gmapsPlacesLoader) {
      try {
        if (process.env.NODE_ENV !== "production") {
          console.log(
            "[Maps] Waiting for existing Google Maps loader to finish..."
          );
        }
      } catch (_) {}
      window.__gmapsPlacesLoader
        .then(() => resolve(window.google))
        .catch(reject);
      return;
    }

    try {
      if (process.env.NODE_ENV !== "production") {
        console.log(
          `[Maps] Loading Google Maps JS API (Places). API key present (length=${
            String(apiKey).length
          }).`
        );
      }
    } catch (_) {}

    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
      apiKey
    )}&libraries=places&v=quarterly`;

    const p = new Promise((res, rej) => {
      script.onload = () => {
        if (window.google && window.google.maps && window.google.maps.places) {
          try {
            if (process.env.NODE_ENV !== "production") {
              console.log(
                "[Maps] Google Maps JS API (Places) loaded successfully"
              );
            }
          } catch (_) {}
          res(window.google);
        } else {
          rej(
            new Error("Google Maps loaded, but Places library not available")
          );
        }
      };
      script.onerror = () => {
        try {
          console.error("[Maps] Failed to load Google Maps JS API");
        } catch (_) {}
        rej(new Error("Failed to load Google Maps JS API"));
      };
    });

    window.__gmapsPlacesLoader = p;
    document.head.appendChild(script);

    p.then(() => resolve(window.google)).catch(reject);
  });
}
